<template>
  <div></div>
</template>

<script>
import Event from '@/helper/event.js'
export default {
  mixins: [Event],
  computed: {
    action() {
      return 'duplicate'
    },
    designIdeaId() {
      return this.config?.data?._id
    },
    submitUri() {
      return `design-idea/duplicate/${this.designIdeaId}`
    }
  },
  created() {
    this.submit()
  },
  methods: {
    submit() {
      this.submitForm(
        this.data,
        {
          done: (response) => {
            if (!_.isUndefined(response.id)) {
              this.$emitter.emit('Modal', {
                name: 'design-idea.edit',
                data: {
                  _id: response.id
                }
              })
            }
          }
        },
        {
          $el: document.body
        }
      )
    }
  },
  props: {
    config: Object
  }
}
</script>
